import * as Config from '../config';
import React, { useState, useContext } from "react";
import { useSelector, useDispatch, ReactReduxContext } from 'react-redux';

import {
  setModal,
  openDrawer,
  setSelectedItems,
} from "../actions/index";

import Input from '../components/library/form/Input';
import ModalCTA from '../components/library/modal/ModalCTA';

const usePlaylist = (playlist, path = null, type = null, isSubscribed) => {
  const { store } = useContext(ReactReduxContext);
  const dispatch = useDispatch();
  const api = useSelector(state => state.api);

  const dragMore = (items, type, next) => {
    const req = (next.includes(`https`)) ? api.getFromURL(next) : api.getFromApi(next, false);
    req.then( response => {
      const sItems = (type !== 'playlists') ? response.data.results : response.data.results.map( x => { x.track.item_id = x.id; return x.track } );
      const newItems = [...items, ...sItems.map(Config.formattedFromBP)];
      if (response.data.next) {
        dragMore(newItems, type, response.data.next);
      } else {
        dispatch(setSelectedItems(newItems));
      }
    } ).catch( e => console.log(`error`, e) );
  }

  const beginDrag = () => {
    dispatch(openDrawer());
    if (path) {
      const nbTracks = (playlist.track_count) ? playlist.track_count : 100;
      dragMore([], type, `${path}/tracks/?per_page=${nbTracks}`);
    } else {
      dispatch(setSelectedItems([...playlist.tracks]));
    }
  };

  const copyLocalToAPI = () => {
    const state = store.getState();
    const isConnected = state.isConnected;

    if (isConnected) {
      const validClick = (name) => {
        const state = store.getState();
        const sharedPlaylist = state.storePlaylists.get(playlist.id);
        if (sharedPlaylist) {
          const data = sharedPlaylist.tracks;
          state.storePlaylists.new(name, sharedPlaylist.tracks, {});
          const dataEvent = data.map( x => ({ track_id: x.id, source_item_type: `Playlist`, source_item_id: playlist.id }) );
          state.storePlaylists.report(`/events/save-to-library/`, dataEvent);
        }
      }
      dispatch(setModal({ //V2
        content: (
          <ModalCTA
            title={`Save this playlist`}
            styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
            styleBody={{gap: 16}}
            styleGroupCta={{gap: 32}}
            classModal={`bottom-reduce`}
          >
            <Input label={`Name`} labelValid={`Create`} validClick={validClick} placeholder={`My Playlist`} value={playlist.name} />
          </ModalCTA>
        )
      }));
    } else {
      state.storeAuth.signupPM();
    }

  }

  const [ activeFilters, setActiveFilters ] = useState(false);
  const showFilters = () => {
    if (document.getElementsByClassName(`button-filter basic`)[0]) {
      document.getElementsByClassName(`button-filter basic`)[0].click();
      setActiveFilters(!activeFilters);
    }
  }
  const clearFilters = () => {
    if (document.getElementsByClassName(`button-filter-clear basic`)[0]) {
      document.getElementsByClassName(`button-filter-clear basic`)[0].click();
    }
  }

  const storeX = {
    beginDrag,
    copyLocalToAPI,
    activeFilters,
    showFilters,
    clearFilters,
  };

  return storeX;
};

export default usePlaylist;
